<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <h2 ref="tituloRef" class="titulo">DRESS CODE</h2>
    <p ref="subtituloRef" class="formal">FORMAL</p>

    <!-- Ícono -->
    <div class="icono-container">
      <img
        ref="parejaRef"
        src="@/assets/dresscode.svg"
        alt="Dress code ícono elegante"
      />
    </div>

    <!-- Colores reservados -->
    <p ref="p2Ref" class="descripcion colores-reservados">
Reservamos el color Blanco exclusivamente para la novia.    </p>
   <!-- Paleta -->
  

 
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'DressCode',
  setup() {
    const dressCodeRef = ref(null)
    const tituloRef = ref(null)
    const subtituloRef = ref(null)
    const p2Ref = ref(null)
    const parejaRef = ref(null)
    const paletaRef = ref(null)
    const linksRef = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {

              const tl = gsap.timeline({
                defaults: { ease: 'power2.out' }
              })

              tl.fromTo(
                tituloRef.value,
                { opacity: 0, y: -30 },
                { opacity: 1, y: 0, duration: 0.6 }
              )
              .fromTo(
                subtituloRef.value,
                { opacity: 0, y: 20 },
                { opacity: 1, y: 0, duration: 0.5 },
                '-=0.3'
              )
              .fromTo(
                parejaRef.value,
                { opacity: 0, scale: 0.85 },
                { opacity: 1, scale: 1, duration: 0.6 },
                '-=0.2'
              )
              .fromTo(
                p2Ref.value,
                { opacity: 0, y: 25 },
                { opacity: 1, y: 0, duration: 0.6 },
                '-=0.2'
              )
              .fromTo(
                linksRef.value.children,
                { opacity: 0, y: 15 },
                { opacity: 1, y: 0, duration: 0.4, stagger: 0.15 },
                '-=0.2'
              )
              .fromTo(
                paletaRef.value,
                { opacity: 0, y: 25 },
                { opacity: 1, y: 0, duration: 0.6 },
                '-=0.2'
              )

              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.25 }
      )

      observer.observe(dressCodeRef.value)
    })

    return {
      dressCodeRef,
      tituloRef,
      subtituloRef,
      p2Ref,
      parejaRef,
      paletaRef,
      linksRef
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  background-color: #f2eee8;
  color: #1a1a1a;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Playfair Display', serif;
}

.titulo {
  font-size: 28px;
  letter-spacing: 2px;
  margin-bottom: 0;
    color: #1a1a1a;

  font-weight: 500;
}

.formal {
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  font-style: italic;
  margin-top: 10px;
  margin-bottom: 18px;
  letter-spacing: 1.5px;
}

.descripcion {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 18px;
}

.colores-reservados {
  font-size: 15px;
}

.icono-container img {
  width: 220px;
  margin: 10px auto 20px;
  opacity: 0;
  filter: brightness(0.5);
}

/* Pinterest */
.pinterest-links {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pinterest-btn {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  padding: 8px 18px;
  border-radius: 25px;
  background: #1a1a1a;
  color: #fff;
  text-decoration: none;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}

.pinterest-btn:hover {
  background: #444;
  transform: translateY(-2px);
}

/* Paleta */
.paleta-container {
  margin-top: 15px;
  opacity: 0;
}

.paleta-img {
  max-width: 260px;
  width: 100%;
}
</style>